import { render, staticRenderFns } from "./kechengziyemian.vue?vue&type=template&id=02134a4f&scoped=true"
var script = {}
import style0 from "./kechengziyemian.vue?vue&type=style&index=0&id=02134a4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02134a4f",
  null
  
)

export default component.exports